import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';

/**
 * F10: indicadores de Pessoas no Início. ROB-01: cada cartão é o CartaoIndicador do núcleo (CONTRATOS §7.13), que
 * mostra reticências só enquanto carrega e, se a API falhar, o traço com "Tentar de novo" no próprio cartão.
 */
function Indicadores() {
  const { t } = useTranslation('pessoas');
  const q = useQuery({ queryKey: ['pessoas', 'indicadores'], queryFn: () => api<{ ativos: number; admitidos_30: number; documentos_alerta: number; onboarding_pendente: number }>('/api/v1/pessoas/indicadores') });
  const itens = [
    { rotulo: t('indicadores.ativos'), valor: q.data?.ativos, link: '/pessoas/funcionarios' },
    { rotulo: t('indicadores.documentos'), valor: q.data?.documentos_alerta, link: '/pessoas/documentos', atencao: !!q.data?.documentos_alerta },
    { rotulo: t('indicadores.onboarding'), valor: q.data?.onboarding_pendente, link: '/pessoas/funcionarios' },
  ];
  return (
    <>
      {itens.map((i) => (
        <CartaoIndicador
          key={i.rotulo}
          rotulo={i.rotulo}
          consultas={[q]}
          valor={i.valor == null ? null : <Link to={i.link} className={`hover:text-acento ${i.atencao ? 'text-laranja' : ''}`}>{i.valor}</Link>}
        />
      ))}
    </>
  );
}

const carregar0 = () => import('./Comum');
const carregar1 = () => import('./Funcionarios');
const carregar2 = () => import('./FichaFuncionario');
const carregar3 = () => import('./Estrutura');
const carregar4 = () => import('./Contratos');
const carregar5 = () => import('./Documentos');
const carregar6 = () => import('./Jornadas');
const carregar7 = () => import('./Habilidades');

const AcaoNovo = acaoSobDemanda(carregar0, 'AcaoNovo');
const Funcionarios = telaSobDemanda(carregar1, 'Funcionarios');
const FichaFuncionario = telaSobDemanda(carregar2, 'FichaFuncionario');
const Departamentos = telaSobDemanda(carregar3, 'Departamentos');
const Funcoes = telaSobDemanda(carregar3, 'Funcoes');
const Contratos = telaSobDemanda(carregar4, 'Contratos');
const AcaoDocumentos = acaoSobDemanda(carregar5, 'AcaoDocumentos');
const Documentos = telaSobDemanda(carregar5, 'Documentos');
const Jornadas = telaSobDemanda(carregar6, 'Jornadas');
const Habilidades = telaSobDemanda(carregar7, 'Habilidades');

export const modulo: ModuloWeb = {
  slug: 'pessoas',
  menu: 'pessoas',
  dicionario,
  abas: [
    { rotulo: 'abas.funcionarios', caminho: 'funcionarios', elemento: <Funcionarios />, Acao: () => <AcaoNovo rotulo="acoes.admitir" />, ordem: 1 },
    { rotulo: 'abas.departamentos', caminho: 'departamentos', elemento: <Departamentos />, Acao: () => <AcaoNovo rotulo="acoes.novoDepartamento" />, ordem: 2 },
    { rotulo: 'abas.funcoes', caminho: 'funcoes', elemento: <Funcoes />, Acao: () => <AcaoNovo rotulo="acoes.novaFuncao" />, ordem: 3 },
    { rotulo: 'abas.contratos', caminho: 'contratos', elemento: <Contratos />, ordem: 4 },
    { rotulo: 'abas.documentos', caminho: 'documentos', elemento: <Documentos />, Acao: AcaoDocumentos, ordem: 5 },
    { rotulo: 'abas.jornadas', caminho: 'jornada-e-escala', elemento: <Jornadas />, Acao: () => <AcaoNovo rotulo="acoes.novaJornada" />, ordem: 6 },
    { rotulo: 'abas.habilidades', caminho: 'habilidades', elemento: <Habilidades />, Acao: () => <AcaoNovo rotulo="acoes.novaHabilidade" />, ordem: 7 },
  ],
  rotas: [{ path: 'pessoas/funcionarios/:id', element: <FichaFuncionario /> }],
  Indicadores,
};
